import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";


const ReusableForm = ({
  initialValues,
  validationSchema,
  onSubmit,
  fromDate,
  isSelected,
  fieldtype,
  formik,
  btn_name,
  forlogin,
  title,
  label_size,
  col_size,
  disable,
  check_box_true,
  row_size,
  additional_field,
  showImagePreview,
  placeholderdata,
  disabled,
  LastUSerName,
  removebtn,
  hidebtn,
  
}) => {
  const location = useLocation();
  const [passwordVisible, setPasswordVisible] = useState({});
  const [previews, setPreviews] = useState([]);

  const handleFileChange = (event, index, name) => {
    if (event.target.files[0].size > 420000) {
      alert("Please  Select file less then 420KB");
      event.target.value = "";
      return;
    } else {
      const file = event.target.files[0];
      const newPreviews = [...previews];

      newPreviews[index] = URL.createObjectURL(file);
      setPreviews(newPreviews);

      const reader = new FileReader();
      reader.onload = () => {
        formik.setFieldValue(name, reader.result);
      };

      reader.readAsDataURL(file);
    }
  };

  const getCurrentDate = () => {
    const today = new Date();
    const year = today.getFullYear();
    let month = today.getMonth() + 1;
    let day = today.getDate();

    if (month < 10) {
      month = `0${month}`;
    }
    if (day < 10) {
      day = `0${day}`;
    }
    return `${year}-${month}-${day}`;
  };

  const Removeimg = () => {
    formik.setFieldValue("logo", "");
    formik.setFieldValue("favicon", "");
    formik.setFieldValue("watermark", "");
    formik.setFieldValue("loginimg", "");
    formik.setFieldValue("Emaillogo", "");
    setPreviews([]);
  };



  return (
    <form onSubmit={formik.handleSubmit}>
      <div
        className=" "
        style={{
          height: `${title === "addgroup" ? "65vh" : ""}`,
          overflowY: `${title === "addgroup" ? "scroll" : ""}`,
        }}
      >
        <div className={`row g-3 align-items-baseline`}>
          {fieldtype.map((field, index) => (
            <>
              {field.type === "lastusername" ? (
                <>
                  <span className="fw-bold">
                    Last User Name : {LastUSerName}
                  </span>
                </>
              ) : field.type === "select" ? (
                <>
                  <div className={`col-6 col-lg-${field.col_size}`}>
                    <div className=" row">
                      <label
                        className={`col-lg-${title === "forlogin"
                          ? 3
                          : title === "update_theme"
                            ? 12
                            : 7
                          }  `}
                        htmlFor={field.name}
                      >
                        {field.label}
                        {field.madatory && (
                          <span className="text-danger">*</span>
                        )}
                      </label>
                      <div
                        className={`col-lg-${title === "addgroup" ? 12 : 12}`}
                      >
                        <select
                          className="default-select wide form-select"
                          id={field.name}
                          {...formik.getFieldProps(field.name)}
                          disabled={field.disable}
                        >
                          <option value="" selected disable={field.disable}>
                            Please Select {field.label}
                          </option>
                          {field.options.map((option) => (
                            <option key={option.value} value={option.value}>
                              {option.label}
                            </option>
                          ))}
                        </select>

                        {field.name == "broker" &&
                          formik.values.broker == 7 && (
                            <div style={{ fontSize: "12px", color: "red" }}>
                              You should save the mobile number which is
                              registered in the account of Kotak Neo in the
                              mobile number field.
                            </div>
                          )}

                        {formik.touched[field.name] &&
                          formik.errors[field.name] && (
                            <div style={{ fontSize: "12px", color: "red" }}>
                              {formik.errors[field.name]}
                            </div>
                          )}
                      </div>
                    </div>
                  </div>
                </>
              ) : field.type === "checkbox" ? (
                <>
                  {field.options && field.options.length > 0 ? (
                    <>
                      {field.options &&
                        field.options.map((option, index) => (
                          <>
                            <div
                              className={`col-6 col-lg-${field.col_size}`}
                              key={option.id}
                            >
                              <div className="row d-flex">
                                <div className={`col-6  col-lg-${field.col_size}`}>
                                  <div className="form-check custom-checkbox ">
                                    <input
                                      type={field.type}
                                      className="form-check-input"
                                      id={option.label}
                                      {...formik.getFieldProps(option.name)}
                                    />
                                    <label
                                      className="ms-1 form-check-label"
                                      htmlFor={option.label}
                                    >
                                      {option.label}
                                    </label>
                                  </div>
                                  {formik.touched[field.name] &&
                                    formik.errors[field.name] && (
                                      <div
                                        style={{
                                          fontSize: "12px",
                                          color: "red",
                                        }}
                                      >
                                        {formik.errors[field.name]}
                                      </div>
                                    )}
                                </div>
                              </div>
                            </div>
                          </>
                        ))}
                    </>
                  ) : (
                    <>
                      <div className={`col-6 col-lg-${field.col_size}`}>
                        <div className="row d-flex">
                          <div
                          //  className={`col-lg-${field.col_size}`}
                          >
                            <div className="form-check custom-checkbox ">
                              <input
                                type={field.type}
                                className="form-check-input"
                                id={field.label}
                                {...formik.getFieldProps(field.name)}
                                checked={field.check_box_true}
                              />
                              <label
                                className="ms-1 form-check-label"
                                htmlFor={field.label}
                              >
                                {field.label}
                              </label>
                            </div>
                            {formik.touched[field.name] &&
                              formik.errors[field.name] && (
                                <div style={{ fontSize: "12px", color: "red" }}>
                                  {formik.errors[field.name]}
                                </div>
                              )}
                          </div>
                        </div>
                      </div>
                    </>
                  )}
                </>
              ) : field.type === "radio" ? (
                <>
                  <label
                    className={`col-lg-${field.label_size} col-form-label fw-bold text-decoration-underline`}
                    htmlFor={field.parent_label}
                  >
                    {field.parent_label}
                  </label>

                  <div className={`d-flex`}>
                    <div
                      className={`col-lg-${field.col_size} form-check custom-checkbox my-3`}
                    >
                      <input
                        type={field.type}
                        name={field.name}
                        value={field.value1}
                        className="form-check-input"
                        id={field.title1}
                        {...formik.getFieldProps(field.name)}
                      />
                      <label
                        className={`col-lg-${field.label_size} col-form-label mx-2`}
                        htmlFor={field.title1}
                      >
                        {field.title1}
                      </label>
                    </div>
                    <div
                      className={`col-lg-${field.col_size} form-check custom-checkbox my-3`}
                    >
                      <input
                        type={field.type}
                        name={field.name}
                        value={field.value2}
                        className="form-check-input"
                        id={field.title2}
                        {...formik.getFieldProps(field.name)}
                      />
                      <label
                        className={`col-lg-${field.label_size} col-form-label  mx-2`}
                        htmlFor={field.name}
                      >
                        {field.title2}
                      </label>
                    </div>
                  </div>
                </>
              ) : field.type === "password" ? (
                <>
                  <div className={`col-6 col-lg-${field.col_size}`}>
                    <div className=" row">
                      <label
                        className={`col-lg-${field.label_size} `}
                        htmlFor={field.name}
                      >
                        {field.label}
                        {field.madatory && (
                          <span className="text-danger">*</span>
                        )}
                      </label>
                      <div style={{ position: "relative" }}>
                        <input
                          id={field.name}
                          type={
                            passwordVisible[field.name] ? "text" : field.type
                          }
                          placeholder={field.label}
                          {...formik.getFieldProps(field.name)}
                          className={` form-control`}
                        />
                        <i
                          className={`fa-solid ${passwordVisible[field.name]
                            ? "fa-eye-slash"
                            : "fa-eye"
                            }`}
                          style={{
                            position: "absolute",
                            fontSize: '13px',
                            top: "-3px",
                            right: "20px",
                            padding: "12.4px 6.6px",
                            borderRadius: "3px",
                          }}
                          onClick={() =>
                            setPasswordVisible((prevState) => ({
                              ...prevState,
                              [field.name]: !prevState[field.name],
                            }))
                          }
                        ></i>
                        {formik.touched[field.name] &&
                          formik.errors[field.name] && (
                            <div style={{ fontSize: "12px", color: "red" }}>
                              {formik.errors[field.name]}
                            </div>
                          )}
                      </div>
                    </div>
                  </div>
                </>
              ) : field.type === "date1" ? (
                <>
                  <div className="col-lg-4 col-6">
                    <div className="row d-flex">
                      <div className="col-lg-12 ">
                        <div className="form-check custom-checkbox ps-0">
                          <label className="col-lg-6 " htmlFor={field.name}>
                            {field.label}
                          </label>
                          <input
                            type="date"
                            name={field.name}
                            className="form-control"
                            id={field.name}
                            {...formik.getFieldProps(field.name)}
                            readOnly={field.disable}
                            // min={getCurrentDate()}

                            min={
                              field.name === "todate"
                                ? fromDate
                                : getCurrentDate()
                            }
                          />
                        </div>
                        {formik.touched[field.name] &&
                          formik.errors[field.name] && (
                            <div style={{ fontSize: "12px", color: "red" }}>
                              {formik.errors[field.name]}
                            </div>
                          )}
                      </div>
                    </div>
                  </div>
                </>
              ) : field.type === "datenew" ? (
                <>
                  <div className={` col-6 col-lg-${field.col_size}`}>
                    <div className="row d-flex">
                      <div className="col-lg-12 ">
                        <div className="ps-0 form-check custom-checkbox ps-0 ">
                          <label className="col-lg-6 " htmlFor={field.name}>
                            {field.label}
                          </label>
                          <input
                            type="date"
                            name={field.name}
                            className="form-control"
                            id={field.name}
                            {...formik.getFieldProps(field.name)}
                            readOnly={field.disable}
                            // min={getCurrentDate()}

                            min={
                              field.name === "todate"
                                ? fromDate
                                : getCurrentDate()
                            }
                          />
                        </div>
                        {formik.touched[field.name] &&
                          formik.errors[field.name] && (
                            <div style={{ fontSize: "12px", color: "red" }}>
                              {formik.errors[field.name]}
                            </div>
                          )}
                      </div>
                    </div>
                  </div>
                </>
              ) : field.type === "date" ? (
                <>
                  <div className="col-lg-3">
                    <div className="row d-flex">
                      <div className="col-lg-12 ">
                        <div className="form-check custom-checkbox ps-0">
                          <label className="col-lg-6 " htmlFor={field.name}>
                            {field.label}
                          </label>
                          <input
                            type={field.type}
                            name={field.name}
                            className="form-control"
                            id={field.name}
                            {...formik.getFieldProps(field.name)}
                            readOnly={field.disable}
                          />
                        </div>
                        {formik.touched[field.name] &&
                          formik.errors[field.name] && (
                            <div style={{ fontSize: "12px", color: "red" }}>
                              {formik.errors[field.name]}
                            </div>
                          )}
                      </div>
                    </div>
                  </div>
                </>
              ) : field.type === "msgbox" ? (
                <>
                  <div className={`col-lg-${field.col_size}`}>
                    <div className="row d-flex">
                      <div>
                        <div>
                          <label
                            className={`col-lg-${field.label_size}`}
                            htmlFor={field.name}
                          >
                            {field.label}
                          </label>

                          <ReactQuill
                            theme="snow"
                            value={formik.values[field.name] || ""}
                            onChange={(value) => formik.setFieldValue(field.name, value)}
                            onBlur={() => formik.setFieldTouched(field.name, true)}
                            modules={{
                              toolbar: [
                                [{ header: [1, 2, 3, false] }],
                                ["bold", "italic", "underline", "strike"],
                                [{ list: "ordered" }, { list: "bullet" }],
                                ["link", "image"],
                                ["clean"],
                              ],
                            }}
                            formats={[
                              "header",
                              "bold",
                              "italic",
                              "underline",
                              "strike",
                              "list",
                              "bullet",
                              "link",
                              "image",
                            ]}
                            style={{
                              backgroundColor: "white",
                              color: "black",
                              minHeight: "150px",
                            }}
                          />

                          {formik.touched[field.name] && formik.errors[field.name] && (
                            <div style={{ fontSize: "12px", color: "red" }}>
                              {formik.errors[field.name]}
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              ) : field.type === "test" ? (
                <>
                  <div className="col-lg-3 col-6 ">
                    <div className="row d-flex">
                      <div className="col-lg-12 ">
                        <div className="form-check custom-checkbox ">
                          <input
                            type={field.type}
                            name={field.name}
                            className="form-check-input"
                            id={field.name}
                            {...formik.getFieldProps(field.name)}
                          />
                          <label
                            className="ms-1 form-check-label"
                            htmlFor={field.name}
                          >
                            {field.name}
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              ) : field.type === "placeholder" ? (
                <>
                  <div className={`col-lg-${field.col_size}`}>
                    <div className=" row flex-column">
                      <label
                        className={`col-lg-${field.label_size}`}
                        htmlFor={field.name}
                      >
                        {field.label}
                        {field.madatory && (
                          <span className="text-danger">*</span>
                        )}
                      </label>
                      <div>
                        <input
                          type="text"
                          className="form-control"
                          id={field.name}
                          placeholder={`Ex :- ${field.placeholderdata}`}
                          {...formik.getFieldProps(field.name)}
                          readOnly={field.disable}
                        />
                        <div className="invalid-feedback">
                          Please enter {field.label}
                        </div>
                        {formik.touched[field.name] &&
                          formik.errors[field.name] && (
                            <div style={{ fontSize: "12px", color: "red" }}>
                              {formik.errors[field.name]}
                            </div>
                          )}
                      </div>
                    </div>
                  </div>
                </>
              ) : field.type === "file" ? (
                <>
                  <div className={`col-lg-${field.col_size}`}>
                    <div className="row d-flex">
                      <div className="">
                        <label
                          className={`col-form-${field.label_size}`}
                          htmlFor={field.name}
                        >
                          {field.label}
                          {field.madatory && (
                            <span className="text-danger">*</span>
                          )}
                        </label>
                        <input
                          type="file"
                          id={field.name}
                          onChange={(e) =>
                            handleFileChange(e, index, field.name)
                          } // Pass the index to the handler
                          className={`form-control`}
                        />
                      </div>
                      <img
                        src={
                          formik.getFieldProps(field.name).value
                            ? formik.getFieldProps(field.name).value
                            : (field.default_img || "https://cdn-icons-png.flaticon.com/512/2748/2748558.png")
                        }
                        name={field.name}
                        id={field.name}
                        alt={`Preview ${index}`}
                        className={`col-lg-11 ms-3 mt-2 mb-2 rounded ${field.label_size} border border-2`}
                        style={{
                          height: "150px",
                          width: "95%",
                          objectFit: "contain",
                          backgroundColor: "#f8f9fa",
                          borderRadius: "10px",
                          boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
                        }}
                      />
                    </div>
                  </div>
                </>
              ) : field.type === "number" ? (
                <>
                  <div className={`col-6 col-lg-${field.col_size}`}>
                    <div className=" row flex-column">
                      <label
                        className={`col-lg-${field.label_size}`}
                        htmlFor={field.name}
                      >
                        {field.label}
                        {field.madatory && (
                          <span className="text-danger">*</span>
                        )}
                      </label>
                      <div>
                        <input
                          type="text"
                          className="form-control"
                          id={field.name}
                          placeholder={`Enter ${field.label}`}
                          maxLength={10}
                           list={field.list || undefined} 
                          {...formik.getFieldProps(field.name)}
                          onInput={(e) => {
                            e.target.value = e.target.value
                              .replace(/[^0-9]/g, "")
                              .slice(0, 10);
                          }}
                          readOnly={field.disable}
                        />

                        <div className="invalid-feedback">
                          Please enter {field.label}
                        </div>
                        {formik.touched[field.name] &&
                          formik.errors[field.name] && (
                            <div style={{ fontSize: "12px", color: "red" }}>
                              {formik.errors[field.name]}
                            </div>
                          )}
                      </div>
                    </div>
                  </div>
                </>
              ) : (
                <>
                  <div className={`col-6 col-lg-${field.col_size}`}>
                    <div className=" row flex-column">
                      <label
                        className={`col-lg-${field.label_size}`}
                        htmlFor={field.name}
                      >
                        {field.label}
                        {field.madatory && (
                          <span className="text-danger">*</span>
                        )}
                      </label>
                      <div>
                        <input
                          type="text"
                          className="form-control"
                          id={field.name}
                          placeholder={`Enter ${field.label}`}
                           list={field.list || undefined} 
                          {...formik.getFieldProps(field.name)}
                          readOnly={field.disable}
                        />
                        <div className="invalid-feedback">
                          Please enter {field.label}
                        </div>
                        {formik.touched[field.name] &&
                          formik.errors[field.name] && (
                            <div style={{ fontSize: "12px", color: "red" }}>
                              {formik.errors[field.name]}
                            </div>
                          )}
                      </div>
                    </div>
                  </div>
                </>
              )}
            </>
          ))}
        </div>
        {additional_field}
        <div className="row mt-2 justify-content-end">
          {removebtn && (
            <div
              className={`${removebtn ? "col-12 col-md-6" : "col-12 col-md-2"
                } mb-2`}
            >
              <button
                className={`btn btn-danger w-100`}
                type="button"
                onClick={Removeimg}
              >
                Remove Image
              </button>
            </div>
          )}

          {!hidebtn && (
            <div
              className={`${location.pathname === "resetpassword"
                ? "col-12 col-md-11"
                : removebtn
                  ? "col-12 col-md-6"
                  : "col-12 col-md-4"
                } mb-2`}
            >
              <button className="btn btn-primary float-md-end " type="submit">
                {btn_name}
              </button>
            </div>
          )}
        </div>
      </div>
    </form>
  );
};

export default ReusableForm;
